import { h, Component } from "preact";
import { Link } from "preact-router/match";
import style from "./style";

export default class Header extends Component {
  state = {
    sidenavOpened: false
  };

  constructor() {
    super();
  }

  toggleSidenav = () => {
    this.setState({ sidenavOpened: !this.state.sidenavOpened });
  };

  render() {
    return (
      <div>
        <header class={style.header}>
          <button
            aria-label="Toggle sidenav"
            class={style.menuButton}
            onClick={this.toggleSidenav}
          >
            <span />
          </button>
          <h1>Bridges puzzle solver</h1>
        </header>
        <div
          class={
            style.sidenav + " " + (this.state.sidenavOpened ? style.opened : "")
          }
        >
          <nav>
            <Link activeClassName={style.active} href="/">
              Solver
            </Link>
            <Link activeClassName={style.active} href="/how-to">
              How to play
            </Link>
            <Link activeClassName={style.active} href="/about">
              About
            </Link>
          </nav>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/index.js